import React from 'react';
import { Badge } from 'react-bootstrap';
import { getConfig } from '../../config';
import { Stage } from '../../config/ApplicationConfig';

export const EnvironmentIndicator: React.FC = () => {
  const config = getConfig();

  // Only show in non-production environments
  if (config.stage === Stage.PROD) {
    return null;
  }

  const badgeColor =
    config.stage === Stage.LOCAL ? 'success' : config.stage === Stage.DEV ? 'info' : 'warning';

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '10px',
        right: '10px',
        zIndex: 1000,
      }}
    >
      <Badge bg={badgeColor} className="px-2 py-1">
        {config.stage.toUpperCase()}
      </Badge>
    </div>
  );
};

export default EnvironmentIndicator;
